export function registerDeleteAssetEvents(obj, id) {
	obj.ready(function () {
		if (typeof useralerts !== 'undefined' && typeof userassets !== 'undefined' && useralerts.length > 0) {
			$('#alert_stockid').html(userassets[id]['symbol']);
			$('#alert_stockname').html(userassets[id]['name']);
			$('#asset_type').html(userassets[id]['assettype']);
		}
	});
}